import * as api from '../../api'
import LikesMix from "./LikesMix";

export default {
  props   : ['work'],
  data() {
    return {
      showFormMenu  : false,
      showMenu      : false,
      showComplaint : false,
      setName       : '',
      collectionName: '',
      to_set_id: $('#app-wrapper').attr('set_id'),
      to_set_type: $('#app-wrapper').attr('set_type'),
      to_is_editable_works: $('#app-wrapper').attr('is_editable_works'),
    }
  },
  mixins: [LikesMix],
  computed: {
    topicId: {
      get() {
        return 'id_new_topic_idm_' + this.work.work_id
      }
    },
    removeCaption: {
      get() {
        if ( this.to_set_type==='selection' ) return this.$t('message.RemoveWorkFromSelection');
        else return this.$t('message.RemoveWork');
      }
    },
    addToSetClick: {
      get() {
        return "action_set.do_add_to_set_new(this, 'selection', '"+this.work.work_id+"')";
      }
    },
  },
  methods: {
    prevent(event) {
      if (event) {
        event.preventDefault()
      }
    },
    toggleLikeWork(event, uri) {
      if (event) event.preventDefault();

      this.toggleLike(event, uri);
      this.showFormMenu  = false
      this.showMenu      = false
      this.showComplaint = false
    },
    toggleMenu(event) {
      if (event) event.preventDefault();

      if (this.userId) {
        this.showMenu      = !this.showMenu
        this.showFormMenu  = false
        this.showComplaint = false
      } else {
        $('#id_popup_dotted_more_idm_c_'+ this.work.work_id).show();
        action_user.show_popup_login(event.target);
        stop_bubble(event);
      }
    },
    toggleComplaint(event) {
      if (event) event.preventDefault();

      this.showComplaint = !this.showComplaint
      this.showFormMenu  = false
    },
    sendComplaint(type, event) {
      if (event) event.preventDefault();

      action_rating.do_add_complaint(
        event.target,
        'work://' + this.work.work_id,
        type,
        '',
        this.$t("message.ComplaintSent"),
        this.$t("message.ComplaintSentError")
      )
    },
    editData(event) {
      if (event) event.preventDefault();
      action_work.show_edit_work(null, this.work.work_id, this.$t("message.AccessDenied"));
    },
    qpromoWork(event) {
      if (event) event.preventDefault();
      let j_target=$(event.target);
      if ( j_target.hasClass('c_need_parent') ) j_target=j_target.parent();
      action_pay.do_load_popup( j_target, 'qpromo', this.work.uri );
    },

    removeWork(event) {
      if (event) event.preventDefault();
      if ( this.to_set_type==='selection' ){
        //удалить из подборки
        action_work.do_del_work(event.target, this.work.work_id, this.to_set_id, '.c-item-'+this.work.work_id,
          this.$t("message.QWorkRemoveFromSelection"), this.$t("message.AccessDenied"), this.$t("message.WorkRemovedFromSelection"));
      }
      else {
        //удалить работу
        action_work.do_del_work(event.target, this.work.work_id, '', '.c-item-'+this.work.work_id,
          this.$t("message.QWorkRemove"), this.$t("message.AccessDenied"), this.$t("message.WorkRemoved"))
      }
    },
  },
  created (){
    this.getLikes(this.work.uri);
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/WorksItemControlsMix.js
// module id = null
// module chunks = 